import React, { useEffect, useCallback } from 'react';
import { FormSpy } from 'react-final-form';
import { usePrevious } from './hooks/use-previous';

function BaseAutosave(props) {
  const prevActive = usePrevious(props.active);

  const handleSave = useCallback(() => {
    props.save(props.values);
  }, [props]);

  useEffect(() => {
    const isDirty = props.submitSucceeded ? props.dirtySinceLastSubmit : props.dirty;
    if (!props.active && prevActive && isDirty) handleSave();
  }, [handleSave, prevActive, props.active, props.dirtySinceLastSubmit, props.dirty, props.submitSucceeded]);

  return null;
}

export default function Autosave(props) {
  return (
    <FormSpy
      {...props}
      subscription={{ active: true, values: true, dirty: true, submitSucceeded: true, dirtySinceLastSubmit: true }}
      component={BaseAutosave}
    />
  );
}
